/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TriggerConditionResponseDto
 */
export interface TriggerConditionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TriggerConditionResponseDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerConditionResponseDto
     */
    conditionType: TriggerConditionResponseDtoConditionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof TriggerConditionResponseDto
     */
    intervalValue: number;
    /**
     * 
     * @type {string}
     * @memberof TriggerConditionResponseDto
     */
    intervalUnit: TriggerConditionResponseDtoIntervalUnitEnum;
}


/**
 * @export
 */
export const TriggerConditionResponseDtoConditionTypeEnum = {
    Time: 'TIME',
    Meter: 'METER'
} as const;
export type TriggerConditionResponseDtoConditionTypeEnum = typeof TriggerConditionResponseDtoConditionTypeEnum[keyof typeof TriggerConditionResponseDtoConditionTypeEnum];

/**
 * @export
 */
export const TriggerConditionResponseDtoIntervalUnitEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH',
    Year: 'YEAR',
    Session: 'SESSION',
    Kwh: 'KWH',
    Hour: 'HOUR'
} as const;
export type TriggerConditionResponseDtoIntervalUnitEnum = typeof TriggerConditionResponseDtoIntervalUnitEnum[keyof typeof TriggerConditionResponseDtoIntervalUnitEnum];


/**
 * Check if a given object implements the TriggerConditionResponseDto interface.
 */
export function instanceOfTriggerConditionResponseDto(value: object): value is TriggerConditionResponseDto {
    if (!('conditionType' in value) || value['conditionType'] === undefined) return false;
    if (!('intervalValue' in value) || value['intervalValue'] === undefined) return false;
    if (!('intervalUnit' in value) || value['intervalUnit'] === undefined) return false;
    return true;
}

export function TriggerConditionResponseDtoFromJSON(json: any): TriggerConditionResponseDto {
    return TriggerConditionResponseDtoFromJSONTyped(json, false);
}

export function TriggerConditionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerConditionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'conditionType': json['conditionType'],
        'intervalValue': json['intervalValue'],
        'intervalUnit': json['intervalUnit'],
    };
}

export function TriggerConditionResponseDtoToJSON(json: any): TriggerConditionResponseDto {
    return TriggerConditionResponseDtoToJSONTyped(json, false);
}

export function TriggerConditionResponseDtoToJSONTyped(value?: TriggerConditionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'conditionType': value['conditionType'],
        'intervalValue': value['intervalValue'],
        'intervalUnit': value['intervalUnit'],
    };
}

